module.exports = __webpack_public_path__ + "static/media/nasa-logo.a86e2635.png";